(() => {
  const requests = new Map();
  const hydrated = new WeakSet();

  async function page(address, section = 'collection', signal) {
    const url = new URL(address, location.origin);
    url.searchParams.set('section_id', section);
    const key = url.href;
    if (!signal && requests.has(key)) return requests.get(key);
    const request = (async () => {
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error(`Products unavailable: ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!doc.querySelector('collection-view')) throw new Error('Collection response missing');
      return {
        cards: [...doc.querySelectorAll('.collection__grid > .product-card')],
        next: doc.querySelector('infinite-scroll[data-has-next="true"]')?.dataset.nextUrl || '',
      };
    })();
    if (!signal) {
      requests.set(key, request);
      request.catch(() => requests.delete(key));
    }
    return request;
  }

  window.ditchStock = { page };

  async function hydrate(list) {
    const limit = Number(list.dataset.stockLimit);
    if (!limit || !list.dataset.stockSource || hydrated.has(list)) return;
    hydrated.add(list);
    const selected = [];
    try {
      for (const availability of ['1', '0']) {
        const url = new URL(list.dataset.stockSource, location.origin);
        url.searchParams.set('filter.v.availability', availability);
        let next = url.href;
        const visited = new Set();
        while (next && selected.length < limit && !visited.has(next)) {
          visited.add(next);
          const result = await page(next);
          selected.push(...result.cards.filter((card) =>
            card.dataset.productId !== list.dataset.stockExclude &&
            card.dataset.available === (availability === '1' ? 'true' : 'false')
          ).slice(0, limit - selected.length));
          next = result.next;
        }
        if (selected.length >= limit) break;
      }
      if (!list.isConnected) return;
      const classes = (list.dataset.stockClass || '').split(' ').filter(Boolean);
      const cards = selected.map((card) => {
        const clone = card.cloneNode(true);
        clone.className = 'product-card';
        clone.classList.add(...classes);
        return clone;
      });
      list.replaceChildren(...cards);
      list.dataset.stockReady = 'true';
      const row = list.closest('product-row');
      if (row?.measureTrack) { row.autoPosition = null; row.measureTrack(); }
    } catch {
      hydrated.delete(list);
    }
  }

  function scan(root) {
    if (root.matches?.('[data-stock-source]')) hydrate(root);
    root.querySelectorAll?.('[data-stock-source]').forEach(hydrate);
  }
  scan(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) scan(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
